module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-card-title', [_c('h2', [_vm._v("\n                OAuth Clients                    \n            ")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showCreateClientForm($event)
      }
    }
  }, [_vm._v("\n                        Create New Client\n                    ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.clients.length === 0) ? _c('p', {
    staticClass: "mb-0 mt-2"
  }, [_vm._v("\n                        You have not created any Clients.\n                    ")]) : _vm._e()])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "offset-xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.tsearch),
      callback: function($$v) {
        _vm.tsearch = $$v
      },
      expression: "tsearch"
    }
  })], 1)], 1), _vm._v(" "), (_vm.clients.length > 0) ? _c('v-data-table', {
    staticClass: "elevation-0",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.clients,
      "search": _vm.tsearch,
      "select-all": "",
      "pagination": _vm.pagination,
      "item-key": "id"
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            class: ['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],
            attrs: {
              "align": "left"
            },
            on: {
              "click": function($event) {
                _vm.changeSort(header.value)
              }
            }
          }, [_c('v-icon', [_vm._v("arrow_upward")]), _vm._v("\n                            " + _vm._s(header.text) + "\n                        ")], 1)
        }), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')], 2)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v("\n                            " + _vm._s(props.item.id) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(props.item.name) + "\n                        ")]), _vm._v(" "), _c('td', [_c('code', [_vm._v(_vm._s(props.item.secret))])]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "success",
          attrs: {
            "small": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.edit(props.item)
            }
          }
        }, [_vm._v("\n                                Edit\n                            ")]), _vm._v(" "), _c('v-btn', {
          staticClass: "error",
          attrs: {
            "small": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.destroy(props.item)
            }
          }
        }, [_vm._v("\n                                Delete\n                            ")])], 1)])]
      }
    }])
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": ""
    },
    model: {
      value: (_vm.dialog1),
      callback: function($$v) {
        _vm.dialog1 = $$v
      },
      expression: "dialog1"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Create Client")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', [_vm._l((_vm.createForm.errors), function(error) {
    return _c('v-layout', {
      key: error.id,
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n                            " + _vm._s(error) + "\n                        ")])], 1)
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name",
      "name": "name",
      "hint": "Something your users will recognize and trust.",
      "id": "create-client-name"
    },
    model: {
      value: (_vm.createForm.name),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "name", $$v)
      },
      expression: "createForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Redirect URL",
      "name": "redirect",
      "hint": "Your application's authorization callback URL.",
      "id": "create-client-redirect"
    },
    model: {
      value: (_vm.createForm.redirect),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "redirect", $$v)
      },
      expression: "createForm.redirect"
    }
  })], 1)], 1)], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog1 = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.store($event)
      }
    }
  }, [_vm._v("Create")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": ""
    },
    model: {
      value: (_vm.dialog2),
      callback: function($$v) {
        _vm.dialog2 = $$v
      },
      expression: "dialog2"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Edit Client")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name",
      "name": "name",
      "hint": "Something your users will recognize and trust.",
      "id": "edit-client-name"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Redirect URL",
      "name": "redirect",
      "hint": "Your application's authorization callback URL.",
      "id": "edit-client-redirect"
    },
    model: {
      value: (_vm.editForm.redirect),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "redirect", $$v)
      },
      expression: "editForm.redirect"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog2 = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.update($event)
      }
    }
  }, [_vm._v("Save Changes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8bd9ce0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/passport/Clients.vue
// module id = 350
// module chunks = 0